(function () {
  'use strict';

  angular.module('app').component('discountCouponProducts', discountCouponProducts());

  function discountCouponProducts() {
    return {
      bindings: {
        productsData: '<',
        products: '=', // !important
        searchLabel: '<',
        searchProductsBy: '=', // !important
        allProductsChecked: '<',
        viewMode: '<',
      },
      controller: DiscountCouponProductsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/discount-coupons/components/discount-coupon-products/discount-coupon-products.component.html',
    };
  }

  function DiscountCouponProductsComponent() {
    const vm = this;

    vm.$onInit = function () {
      vm.atLeastOneProductChecked = vm.productsData.some((product) => product.checked)
        ? true
        : false;
    };

    // public methods
    // -----------------------
    vm.checkAllProducts = function () {
      vm.products.forEach((product) => {
        product.checked = vm.allProductsChecked;
      });

      // callback?
    };

    vm.checkProduct = function () {
      vm.allProductsChecked = vm.products.some((product) => !product.checked) ? false : true;

      vm.atLeastOneProductChecked = vm.products.some((product) => product.checked) ? true : false;
    };

    vm.filterProducts = function () {
      if (!vm.searchProductsBy) {
        vm.products = vm.productsData;
        return;
      }

      vm.products = vm.productsData.filter((product) =>
        product.name.toLowerCase().match(vm.searchProductsBy.toLowerCase())
      );
    };
  }
})();
